export default __webpack_public_path__ + "static/media/gallery-two.3d0e9ac9.jpg";